/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_AdjacentInputs */

const en_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adjacent services`)
};

const ar_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خدمات ذات صلة`)
};

const bn_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এ সম্পর্কিত সার্ভিস`)
};

const de_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`angrenzende Dienste`)
};

const es_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`servicios adyacentes`)
};

const fr_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`services adjacents`)
};

const pt_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serviços adjacentes`)
};

const zh_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相邻服务`)
};

const tr_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bitişik hizmetler`)
};

const ru_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`смежные услуги`)
};

const pl_svd_adjacent = /** @type {(inputs: Svd_AdjacentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`usługi sąsiadujące`)
};

/**
* | output |
* | --- |
* | "adjacent services" |
*
* @param {Svd_AdjacentInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_adjacent = /** @type {((inputs?: Svd_AdjacentInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_AdjacentInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_adjacent(inputs)
	if (locale === "bn") return bn_svd_adjacent(inputs)
	if (locale === "de") return de_svd_adjacent(inputs)
	if (locale === "es") return es_svd_adjacent(inputs)
	if (locale === "fr") return fr_svd_adjacent(inputs)
	if (locale === "pt") return pt_svd_adjacent(inputs)
	if (locale === "zh") return zh_svd_adjacent(inputs)
	if (locale === "tr") return tr_svd_adjacent(inputs)
	if (locale === "ru") return ru_svd_adjacent(inputs)
	if (locale === "pl") return pl_svd_adjacent(inputs)
	return en_svd_adjacent(inputs)
});